export const menuActionTypes = {
    SET_ACTIVE_MENU_POSITION: 'SET_ACTIVE_MENU_POSITION',
};